import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSigninLogin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.855 9.583v1.52h-1.53v1.53h-1.52v1.52h-1.52v3.05h1.52v1.52h1.52v1.53h1.53v1.52h1.52v-4.57h6.1v-3.05h-6.1v-4.57zm-1.53 15.24h1.53v3.05h-1.53Zm0-22.86h1.53v4.57h-1.53Zm-6.09 28.95v-1.52h6.09v-1.52h-6.09V8.063h-1.52v22.85zm-6.1 0h4.58v1.53h-4.58Zm1.53-13.71h1.52v3.05h-1.52Zm0-10.67h3.05v1.53h-3.05Zm-4.57 22.86h3.04v1.52h-3.04Zm1.52-24.38h3.05v1.52h-3.05Zm-4.57 22.86h3.05v1.52h-3.05Zm1.52-24.38h3.05v1.52h-3.05Z\"/><path fill=\"currentColor\" d=\"M3.045.443v1.52h-1.52v25.91h1.52V3.493h1.52v-1.53h16.76V.443z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSigninLogin
